import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GenesysProactiveEmailModalComponent } from './genesys-proactive-email-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    GenesysProactiveEmailModalComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
    SvgIconModule
  ],
  exports: [
    GenesysProactiveEmailModalComponent
  ]
})
export class GenesysProactiveEmailModalModule {
}
